import StatisticsCallout from './statistics-callout'

export default StatisticsCallout
